import './index.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { LoggerProvider } from '@ui/shared/components/Logger';
import Onboarding from './Onboarding';
import Offboarding from './Offboarding';
import SecondCamera from './SecondCamera';
import NotFound from './NotFound';
import Menu from './Menu';
import MissingParams from './MissingParams';
import SessionAlreadyActive from './SessionAlreadyActive';
import NewerTabDetected from './NewerTabDetected';
import TextChat from './TextChat';
import ModalOnboarding from './ModalOnboarding';
import Recording from './Recording';
import SessionRedirect from './SessionRedirect';
import HlsViewerExample from '@ui/shared/components/proctoring/SessionViewer/components/Common/HlsViewer/Example';
import ExamLockdownAndStart from '../components/ExamLockdownAndStart';

import ProctorChat from './ExtensionPopups/ProctorChat';
import Alert from './ExtensionPopups/Alert';
import MediaPermissions from './ExtensionPopups/MediaPermissions';
import Confirmation from './ExtensionPopups/Confirmation';
import Acknowledgement from './ExtensionPopups/Acknowledgement';
import AttachmentMenu from './ExtensionPopups/AttachmentMenu';
import AttachmentItem from './ExtensionPopups/AttachmentItem';
import LiveView from './ExtensionPopups/LiveView';
import Calculator from './ExtensionPopups/Calculator';
import SessionInfo from './ExtensionPopups/SessionInfo';
import SupportChat from './ExtensionPopups/SupportChat';
import ExamPassword from './ExtensionPopups/ExamPassword';
import OtherTabMenu from './ExtensionPopups/OtherTabMenu';
import Layout from '../components/Layouts';
import { config } from '../config';

const App = () => {
  return (
    <LoggerProvider appName="SessionUI"
      logLevel={config.logging.logLevel}
      logDestination={config.logging.logDestination}>
      <Routes>
        {/* Routes with Header and Footer */}

        <Route
          path="/onboarding"
          element={
            <Layout type="default" validPhases={["onboarding", "testing"]} requireAuthentication>
              <Onboarding isReconnect={false} inSession={false} />
            </Layout>
          }
        />
        <Route
          path="/offboarding"
          element={
            <Layout type="default" validPhases={["offboarding"]} requireAuthentication>
              <Offboarding isReconnect={false} inSession={false} />
            </Layout>
          }
        />
        <Route
          path="/second-camera"
          element={
            <SecondCamera isReconnect={false} inSession={false} />
          }
        />
        <Route
          path="/missing-params"
          element={
            <Layout type="default">
              <MissingParams />
            </Layout>
          }
        />
        <Route
          path="/session-already-active"
          element={
            <Layout type="default">
              <SessionAlreadyActive />
            </Layout>
          }
        />
        <Route
          path="/newer-tab-detected"
          element={
            <Layout type="default">
              <NewerTabDetected />
            </Layout>
          }
        />

        {/* Routes without Header and Footer */}
        <Route
          path="/menu"
          element={
            <Layout type="plain">
              <Menu />
            </Layout>
          }
        />
        <Route
          path="/other-tab-menu"
          element={
            <Layout type="plain">
              <OtherTabMenu />
            </Layout>
        }
        />
        <Route
          path="/text-chat"
          element={
            <Layout type="plain" requireAuthentication>
              <TextChat />
            </Layout>
          }
        />
        <Route
          path="/proctor-chat"
          element={
            <Layout type="plain">
              <ProctorChat />
            </Layout>
          }
        />
        <Route
          path="/alert"
          element={
            <Layout type="plain">
              <Alert />
            </Layout>
          }
        />
        <Route
          path="/acknowledgement"
          element={
            <Layout type="plain">
              <Acknowledgement />
            </Layout>
          }
        />
        <Route
          path="/confirmation"
          element={
            <Layout type="plain">
              <Confirmation />
            </Layout>
          }
        />
        <Route
          path="/attachment-item"
          element={
            <Layout type="plain">
              <AttachmentItem />
            </Layout>
          }
        />
        <Route
          path="/live-view"
          element={
            <Layout type="plain">
              <LiveView />
            </Layout>
          }
        />
        <Route
          path="/support-chat"
          element={
            <Layout type="plain" requireAuthentication>
              <SupportChat />
            </Layout>
          }
        />
        <Route
          path="/session-info"
          element={
            <Layout type="plain" requireAuthentication>
              <SessionInfo />
            </Layout>
          }
        />
        <Route
          path="/exam-password"
          element={
            <Layout type="plain">
              <ExamPassword />
            </Layout>
          }
        />
        <Route
          path="/calculator"
          element={
            <Layout type="plain">
              <Calculator />
            </Layout>
          }
        />
        <Route
          path="/attachment-menu"
          element={
            <Layout type="transparent" requireAuthentication>
              <AttachmentMenu />
            </Layout>
          }
        />
        <Route
          path="/media-permissions"
          element={
            <Layout type="plain">
              <MediaPermissions />
            </Layout>
          }
        />
        <Route
          path="/session-redirect"
          element={
            <Layout type="plain" requireAuthentication>
              <SessionRedirect />
            </Layout>
          }
        />
        <Route
          path="/lockdown"
          element={
            <Layout type="default">
              <ExamLockdownAndStart />
            </Layout>
          }
        />
        <Route
          path="/:spMediaAuthToken/installs/:installSid/exams/:examSid/sessions/:sessionSid/recording"
          element={
            <Layout type="plain">
              <Recording />
            </Layout>
          }
        />
        <Route
          path="/hls-viewer-example"
          element={
            <Layout type="plain">
              <HlsViewerExample />
            </Layout>
          }
        />
        <Route path="/modal-onboarding" element={<ModalOnboarding />} />
        {/* 404 Route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </LoggerProvider>
  );
};

export default App;